import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import { createStyles } from 'antd-style';

export type SiderTheme = 'light' | 'dark';

const useStyles = createStyles(() => {
  return {
    selectLang: {
      padding: 4,
    },
    questionLink: {
      display: 'inline-flex',
      padding: 4,
      fontSize: 18,
      color: 'inherit',
    },
  };
});

export const SelectLang: React.FC = () => {
  const { styles } = useStyles();
  return (
    <UmiSelectLang
      className={styles.selectLang}
    />
  );
};

export const Question: React.FC = () => {
  const { styles } = useStyles();
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      className={styles.questionLink}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
